import React, { useEffect } from 'react';

import { useReportingLines, useReportingLinesStore } from '@atlassian/teams';

import ManagersAndTeamsChart from './ReportingLines';

type ReportingLinesWithQueryProps = {
	userId: string;
	product?: string;
};

export const ReportingLinesWithQuery = (props: ReportingLinesWithQueryProps): React.JSX.Element => {
	const { userId } = props;

	const [{ selectedUserId }, { selectUser }] = useReportingLinesStore();
	const userToMakeRequestFor = selectedUserId ?? userId;
	const reportingLinesResponse = useReportingLines(userToMakeRequestFor);

	useEffect(() => {
		selectUser(userId);
	}, [userId, selectUser]);

	return <ManagersAndTeamsChart {...props} reportingLinesResponse={reportingLinesResponse} />;
};
